import React, { useEffect, useState } from "react";
import { withRouter, Switch, Route, Redirect, useLocation } from "react-router";
import Loadable from "react-loadable";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
// 우진 (2026-09-09): 활용백서(/playbook) 섹션은 전용 GNB(Figma 1545:19689:
// 로고 · 활용백서 · 그로잉세일즈 홈 ↗ · 로그인) 와 라이트 푸터(1562:20874)
// 를 쓴다. 라우트 prefix 로 분기 — 아래 Main 참고.
import PlaybookNav from "./components/playbook/PlaybookNav";
import SEOMetatag from "./SEOMetatag";

// 우진 (2026-05-07): react-lottie + pending.json 제거. 이유 (1) main bundle
// 에서 라이브러리 (60KB+) + JSON 페이로드 빼서 LCP 단축, (2) Lottie 는 RAF
// 기반이라 main thread 가 막히면 freeze 되어 더 답답한 인상을 줌. CSS
// spinner 는 GPU 합성으로 돌아 main thread 영향 없음.

// Google Analytics
// 우진 (2026-05-06): Universal Analytics(UA-138205327-1)는 2023-07-01부로 데이터 수집 중단됨.
// react-ga 의존성 및 초기화 제거. GA4(G-RYHXFGN8LV)는 GTM의 "Google 태그"가 담당.
//
// 우진 (2026-05-06): 모듈 로드 시점의 Gtag.pageview() 호출 제거. 첫 페이지
// page_view는 GTM의 "Google 태그"(Initialization - All Pages 트리거)가 자동
// 발사하므로 코드에서 또 호출하면 중복임. SPA 라우트 변경 시점의 pageview만
// 아래 useEffect에서 dataLayer push로 처리.
import * as Gtag from "../src/helpers/Gtag";
import MetaTags from "./helpers/MetaTags";
// (2026-05-07 우진) Membership / Policy 도 lazy 로 통일.
// 이전엔 sync import 라 Membership 의 무거운 코드 (CRM 4-state 스크롤러,
// Grade, Integration 등) 가 main bundle 에 포함됐음. 모바일에서 / 진입
// 시에도 멤버십 페이지 전체 코드를 파싱해야 해서 main thread 가 수 초간
// 블록 → 흰화면 → 갑자기 한 번에 렌더되는 패턴 발생. lazy 로 바꾸면
// 각 페이지 chunk 가 독립되어 / 진입 시 Landing 만 받아옴.

// 우진 (2026-05-07): Lottie → pure CSS spinner. 키프레임은 styles.scss 의
// .loading-spinner 정의. main thread 가 블록되어도 GPU 가 transform 으로
// 그려서 동결 안 됨.
const Loader = () => (
  <div className="loading-back">
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        zIndex: 1050,
      }}
    >
      <div className="loading-spinner" />
    </div>
  </div>
);

class ScrollToTop extends React.Component {
  state = {
    loading: true,
  };
  componentDidUpdate(prevProps) {
    if (
      this.props.location !== prevProps.location ||
      (!prevProps && this.props.location)
    ) {
      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return this.props.children;
  }
}

const ScrollToTopWithRouter = withRouter(ScrollToTop);

// 우진 (2026-04-30): 리뉴얼되지 않은 레거시 페이지 12종(Mini, TableOrder, Kds,
// Waiting, Marketing, Kiosk, Stock, CustomerEvent, GettingStarted, Events,
// FranchiseList, Redirector) 제거. 모두 App.js 외에서 import 되지 않았음.
const Landing = Loadable({
  loader: () => import("./pages/Landing"),
  loading: Loader,
});
const RetailPos = Loadable({
  loader: () => import("./pages/RetailPos"),
  loading: Loader,
});
const FoodPos = Loadable({
  loader: () => import("./pages/FoodPos"),
  loading: Loader,
});
const Crm = Loadable({
  loader: () => import("./pages/Crm"),
  loading: Loader,
});
const Cases = Loadable({
  loader: () => import("./pages/Cases"),
  loading: Loader,
});
const CaseDetail = Loadable({
  loader: () => import("./pages/CaseDetail"),
  loading: Loader,
});
const ExtraService = Loadable({
  loader: () => import("./pages/ExtraService"),
  loading: Loader,
});
const Pricing = Loadable({
  loader: () => import("./pages/Pricing"),
  loading: Loader,
});
const Membership = Loadable({
  loader: () => import("./pages/Membership"),
  loading: Loader,
});
const Policy = Loadable({
  loader: () => import("./pages/Policy"),
  loading: Loader,
});
// 우진 (2026-09-09): 활용백서 리스트/상세. 도입사례(Cases/CaseDetail) 와 같은
// lazy 패턴. 콘텐츠 JSON(src/data/playbook-content) 은 이 chunk 안에서만 로드.
const Playbook = Loadable({
  loader: () => import("./pages/Playbook"),
  loading: Loader,
});
const PlaybookDetail = Loadable({
  loader: () => import("./pages/PlaybookDetail"),
  loading: Loader,
});

// 우진 (2026-05-07): IE11 CustomEvent polyfill IIFE 제거. react-app-polyfill
// 제거와 함께 IE11 지원 자체를 끊었음. 모든 모던 브라우저는 CustomEvent 를
// native 로 지원.

const Main = () => {
  // 우진 (2026-05-06): 초기값을 실제 pathname으로 설정. 기존엔 "/"로 시작해서
  // 다른 경로(/pricing 등)로 진입하면 첫 useEffect가 PAGE_VIEW_LOADED를
  // 발사 → GTM 초기 page_view와 중복됐음.
  const [currentPath, setPath] = useState(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );

  // (2026-05-06) 페이지별 메타가 정의된 핵심 3개 페이지만 별도 분기.
  // 나머지 (crm/cases/extra-service/pricing 등) 는 default landing 메타 사용
  // — public/index.html 의 default 와 동일.
  const getPage = (path) => {
    switch (path) {
      case "/products/membership":
        return MetaTags.membership;
      case "/products/retail-pos":
        return MetaTags.retailPos;
      case "/products/food-pos":
        return MetaTags.foodPos;
      case "/":
      default:
        return MetaTags.landing;
    }
  };

  useEffect(() => {
    if (window.location?.pathname !== currentPath) {
      setPath(window.location?.pathname);
      // 우진 (2026-05-06): SPA 라우트 변경 시 GTM dataLayer에 PAGE_VIEW_LOADED
      // 푸시. GTM의 ga4_page_view 태그가 이를 받아 GA4로 page_view 전송.
      Gtag.pageview(window.location.href);
    }
  });

  // 우진 (2026-09-09): /playbook 이하에서는 전용 GNB + 라이트 푸터.
  // currentPath(state) 는 useEffect 이후에 갱신되어 한 프레임 늦으므로
  // 라우터 location 을 직접 읽는다 (react-router 5.1 hook).
  const location = useLocation();
  const isPlaybook =
    location.pathname === "/playbook" || location.pathname.startsWith("/playbook/");

  // ?embed=1 — 대시보드(sales-web)의 활용백서 모달이 iframe 으로 본문만 띄우는 모드.
  // GNB/푸터를 걷어내고 .margin-navbar 의 상단 여백도 없앤다. prerender 산출물은
  // #root 에 <main class="playbook-post"> 만 굽기 때문에 GNB 가 번쩍이지 않는다.
  const isEmbed = new URLSearchParams(location.search).get("embed") === "1";

  return (
    <>
      <SEOMetatag {...getPage(window.location?.pathname)} />

      <ScrollToTopWithRouter>
        {isEmbed ? null : isPlaybook ? <PlaybookNav /> : <Navbar />}
        <div className={isEmbed ? "" : "margin-navbar"}>
          {/* 우진 (2026-04-30): 리뉴얼되지 않은 레거시 routes 제거.
              /retail, /features/cafe24 redirect 는 inbound SEO 보호용으로 유지. */}
          <Switch>
            <Route path="/" exact component={Landing} />
            <Route path="/products/retail-pos" exact component={RetailPos} />
            <Route path="/retail" exact render={() => <Redirect to="/products/retail-pos" />} />
            <Route path="/products/food-pos" exact component={FoodPos} />
            <Route path="/products/membership" exact component={Membership} />
            <Route path="/features/cafe24" exact render={() => <Redirect to="/products/membership" />} />
            <Route path="/products/crm" exact component={Crm} />
            <Route path="/cases" exact component={Cases} />
            <Route path="/cases/:slug" exact component={CaseDetail} />
            <Route path="/playbook" exact component={Playbook} />
            <Route path="/playbook/:slug" exact component={PlaybookDetail} />
            <Route path="/extra-service" exact component={ExtraService} />
            <Route path="/pricing" exact component={Pricing} />
            <Route path="/policy*" exact component={Policy} />
            <Route render={() => <Redirect to="/" />} />
          </Switch>
        </div>
        {isEmbed ? null : <Footer variant={isPlaybook ? "light" : "dark"} />}
      </ScrollToTopWithRouter>
    </>
  );
};

export default withRouter(Main);
